var options = {
  cellAlign: "left",
  wrapAround: false,
  prevNextButtons: true,
  pageDots: true,
  draggable: false,
};
var carousel = document.querySelector(".trusted-platform-carousel");
if (carousel && carousel.children.length === 4) {
  options.prevNextButtons = false;
  options.pageDots = false;
}
// enable prev/next buttons and center alignment for screens below 650px
if (matchMedia("screen and (max-width: 767px)").matches) {
  options.prevNextButtons = false; // Enable buttons at this size
  options.pageDots = false; // Enable dots as well if needed
  options.wrapAround = true;
  options.cellAlign = "center";
  options.draggable = true;
}

var flkty = new Flickity(carousel, options);

let slideIndex = 0;
const slides = document.querySelectorAll(".multi-row-slider .slide_row");
const slides_inners = document.querySelectorAll(
  ".multi-row-slider .slide_row .image-with-text__grid"
);
function setSliderHeight() {
  const heights = Array.from(slides_inners).map(
    (slides_inner) => slides_inner.offsetHeight
  );
  const maxHeight = Math.max(...heights);
  document.querySelector(".multi-row-slider").style.height = maxHeight + "px";
}
window.onload = setSliderHeight;
window.onresize = setSliderHeight;
function showSlide(index, direction = "left") {
  slides.forEach((slide) => slide.classList.remove("active"));
  slideIndex = (index + slides.length) % slides.length;
  slides[slideIndex].classList.add("active");
}
function changeSlide(step) {
  showSlide(slideIndex + step);
}
showSlide(slideIndex);
